export default __webpack_public_path__ + "static/media/sample3.e35a03dc.mp4";